import type { TStepperProps } from '@/src/elements/stepper/stepper.types'
import { withFraternity } from '@/src/features/fraternity/utils/withFraternity'

import type { TFullCommunityApi } from '../api/communityApi.types'
import { FRATERNITY_QUESTION_STEPS, type TJoinStep, type TFraternityQuestionStep } from '../models/joinSteps.types'

const isFraternityQuestionStep = (step: TJoinStep): step is TFraternityQuestionStep =>
  (FRATERNITY_QUESTION_STEPS as readonly TJoinStep[]).includes(step)

type TGetJoinStepperOptionsParams = {
  stepName: TJoinStep
  joinSteps: TJoinStep[]
  community?: Pick<TFullCommunityApi, 'tags'>
}

export const getJoinStepperOptions = ({
  stepName,
  joinSteps,
  community,
}: TGetJoinStepperOptionsParams): TStepperProps | undefined => {
  const activeSteps = withFraternity(community) ? joinSteps.filter(isFraternityQuestionStep) : joinSteps
  const stepIndex = activeSteps.indexOf(stepName)
  return stepIndex >= 0 ? { currentStep: stepIndex + 1, totalSteps: activeSteps.length } : undefined
}
